import { AxiosResponse } from "axios";

import client from "../client";

import { postSignInMicrosoftConfig } from "./postSignInMicrosoftConfig";

import { PostSignInMicrosoftPayload } from "./types";
import { PostLoginResponseData } from "../postLogin/types";

const postSignInMicrosoft = async (
  data?: PostSignInMicrosoftPayload,
  reference?: string
): Promise<AxiosResponse<PostLoginResponseData>> => {
  return await client({
    ...postSignInMicrosoftConfig,
    data: { reference, provider: "microsoft", ...data },
  });
};

export default { postSignInMicrosoft };
